<div>
  <app-loading-spinner *ngIf="!termDetails && !apiError"></app-loading-spinner>
  <app-api-error-display *ngIf="apiError" [error]="apiError"></app-api-error-display>

  <div id="chemical-details" class="details-page" *ngIf="termDetails">
    <app-social-contact></app-social-contact>

    <div id="chemical-details-menu">
      <app-details-page-menu *ngIf="termDetails"
                             [title]="termDetails.termid"
                             [menuItems]="menuItems"></app-details-page-menu>
    </div>

    <app-term-page-summary [termDetails]="termDetails"></app-term-page-summary>
  </div>
</div>
